<template>
    <div class="modal-window uts005">
        <header class="modal-header">
            <div class="tit">{{ $i18nUtil.trans("title.TargetCall.001","호출") }}</div>
            <button @click="$emit('close')" class="btn_close">{{$i18nUtil.trans("button.close","닫기")}}</button>
        </header>
        
        <div class="modal-content">
            <div class="txt2">{{ $i18nUtil.trans("message.TargetCall.001","@이름 맨션을 통해 호출된 정보를 확인할 수 있습니다.") }}</div>
            <div class="calendar_box_grp">
                <div class="calendar_box">
                    <datepicker format="yyyy.MM.dd" :disabled-dates="startDisabledDate" :value="startDate" @selected="selectedStartDate"></datepicker>
                </div>
                <span>~</span>
                <div class="calendar_box">
                    <datepicker format="yyyy.MM.dd" :disabled-dates="endDisabledDate" :value="endDate" @selected="selectedEndDate" ></datepicker>
                </div>
            </div>
            <div class="clear">
                <div class="fr">
                    <button type="button" class="btn-primary-smaller" @click="deleteCallRead()">{{ $i18nUtil.trans("button.readed.call.delete","읽은 호출 삭제") }}</button>
                    <button type="button" class="btn-primary-smaller" @click="deleteCallAll()">{{ $i18nUtil.trans("button.all.delete","전체 삭제") }}</button>
                    <button type="button" class="btn-refresh" @click="getCallList">{{$i18nUtil.trans("button.refresh","새로고침")}}</button>
                </div> 
            </div>
            <div class="scroll">
                <div class="inner" id="innerScroll">
                    <div class="history clear">
                        <div class="nodata" v-show="dateArray.length == 0">{{ $i18nUtil.trans("message.TargetCall.002","호출 내역이 없습니다.") }}</div>
                        <div class="date_wrap">
                            <div class="task_box_day" v-for="(date, idx) in dateArray" :key="'callArr_'+idx" :class="idx == currentIndex ? '' :'active'">
                                <div class="day" @click="changeDate(date, idx)" :id='date.date' name='day'
                                     v-if="$moment(date.date).format('YYYY-MM-DD') == $moment().format('YYYY-MM-DD')">
                                    {{$i18nUtil.trans("message.today","오늘")}}
                                </div> 
                                <div class="day" @click="changeDate(date, idx)" :id='date.date' name='day'
                                     v-if="$moment(date.date).format('YYYY-MM-DD') <= $moment().subtract(1, 'day').format('YYYY-MM-DD')">   
                                  <!-- <momentAgo prefix="" suffix="전" :date="noti[0].sendDate" lang="kr" ></momentAgo>  -->
                                  {{$moment(date.date).format('YYYY-MM-DD')}}
                                </div>
                                <div class="task_box_case" v-for="(item , callIdx) in callList" :key="callIdx+'call_'+idx" v-show="currentIndex == idx">
                                    <div class="left"></div>
                                    <div class="right">
                                        <div class="task">
                                            <span>{{$moment(item.regDate).format('LT')}}</span>
                                            <span>{{item.callKbn == '과제' ? $i18nUtil.trans("entity.project","과제") :
                                                                            item.callKbn == "정보공유" ? $i18nUtil.trans("entity.cogroup.groupKbn.shar","HO!") : item.callKbn  }}</span>
                                            <span class="ell-singleline" v-if="item.attr3 != null && item.callKbn != '프라이빗'" >
                                                {{ item.attr3 }}
                                            </span>
                                            <span class="borard_name ell-singleline" v-if="item.attr4 != null">
                                                {{ item.attr4 }}
                                            </span>  
                                        </div>
                                        <div class="btm">
                                            <div class="ico-at">@{{defaultLanguage.indexOf('ko') != -1 ? item.recvUserName 
                                                                                : item.recvUserNameEn != null ? item.recvUserNameEn : item.recvUserName}}</div>
                                            <div class="comment" style="cursor: pointer;" @click="readCall(item)" v-html="setTitleMessage(item)"> 
                                            </div>
                                            <span :class="item.readYn == 1 ? '':'ico-new'"></span>
                                        </div>
                                    </div> 
                                </div>  
                                <div class="btn_box txtc">
                                <button type="button" class="btn-more-ico_small1 down" @click="moreData(date)"
                                        v-if="callList.length != 0 && page + 1 < totalPage && currentIndex == idx">
                                        {{$i18nUtil.trans("button.data.more","{cnt}건 더보기",{cnt:totalElements-callList.length > 10 ? '10': totalElements-callList.length})}}</button>
                                </div>      
                            </div><!--//task_box_day-->  
                        </div><!--//date_wrap-->
                    </div><!-- //history -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";

export default {
    components: {
        Datepicker,
    },
    data() {
        return { 
            toastInfo: {
                obj: this.$toasted,
                message: "",
                options: {
                theme: "toasted-primary",
                position: "bottom-left",
                duration: 3000,
                },
            },

            startDate:new Date(this.$moment().subtract(1, "months").format("YYYY-MM-DD")),
            endDate: new Date(this.$moment()),
            startDisabledDate:{ 
                from:new Date(this.$moment())
            },
            endDisabledDate:{ 
                from: new Date(this.$moment()),
                to:new Date(this.$moment().subtract(1, "months").format("YYYY-MM-DD"))
            }, 

            dateArray:[], 
            callList:[],


            currentIndex:0, 
            totalPage:0,
            totalElements:0,
            page : 0, 

            defaultLanguage : localStorage.getItem("defaultLanguage") || 'ko',
            tenantId : localStorage.getItem("tenantId"),
        };
    },
    mounted(){
        this.getCallList();
    },
    methods: {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        /* 토스트 메시지 */
        ...mapActions("modals", ["showToast"]),
        ...mapActions("noti",["setNoneCallReadYn","setNotiBoardBlockId","setNotiBoardCommentId"]),
        ...mapActions("noti", ["setShowCallListPopup"]),
        getCallList(){ 
            this.currentIndex = 0;
            this.dateArray = []; 
            this.callList=[];
            if(this.endDate == null ){ 
                this.endDate = new Date(this.$moment());
            }
            
            let obj = this;
            let reqData = {};
            reqData.params ={
                startDate : obj.$moment(this.startDate).format('YYYY-MM-DD'),
                endDate : obj.$moment(this.endDate).format('YYYY-MM-DD')
            }
            reqData.req = obj.req;
            reqData.url = "/api/noti/call/getCallDateList";
            reqData.method = "post"; 
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(res => {  
                if(res.errorCode != null){
                    console.log(res.errorMessage);
                }else{
                    this.dateArray=[];
                    this.dateArray = res.result.callDateList; 
                    if(this.dateArray.length != 0){
                        this.getCallListPaging(this.dateArray[0].date);
                    }
                } 
            })
            .catch(function(err) {
                console.log(err);
            });
        },
        getCallListPaging(date){
            let obj = this;
            let reqData = {};
            reqData.params = { 
                selectedDate : date,
                page : obj.page
            };
            reqData.req = obj.req;
            reqData.url = "/api/noti/call/getCallListPaging";
            reqData.method = "post"; 
            obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(res => { 
                    if (res.errorCode != null) {
                        console.log(res.errorMessage);
                    } else {
                        obj.totalPage = res.result.callList.totalPages;
                        obj.totalElements = res.result.callList.totalElements;
                        let newList = res.result.callList.content;
                        for(let k in newList){
                            obj.callList.splice(obj.callList.length, 0, newList[k]);
                        }
                    }
                })
                .catch(function(err) {
                    console.log(err);
                });
        },
        changeDate(date, idx){
            if(idx == this.currentIndex) {
                if(!event.target.parentElement.classList.contains("active")) {
                event.target.parentElement.classList.add("active"); 
                this.callList = []; 
                return;
                } else {
                event.target.parentElement.classList.remove("active");
                }
            } 
            this.page =0;
            this.currentIndex = idx; 
            this.callList = [];  
            this.getCallListPaging(date.date); 
            
            const inner = document.getElementById("innerScroll");  

            if(idx == 0 ){
                // inner.scrollTo(0,0);
                inner.scrollTop = 0;
            }else{
                // inner.scrollTo(0,(88*idx)+45);
                inner.scrollTop = (88*idx)+45;
            }
        },
        moreData(date){
            this.page ++;
            this.getCallListPaging(date.date);
        },
        getCallMessage(item){ 
            let message = item.callMessage;
            let retrunMessage="";
            if(message.indexOf('&nbsp;') == -1){
                retrunMessage = message.split("<span data-at-embedded")[0]; 
            }else{
                retrunMessage = message.split("&nbsp;")[0]; 
            }
 
            return retrunMessage;
        },
        deleteCallAll(){
            if(this.dateArray.length == 0){
                return;
            }
            let obj = this;
            let reqData = {};
            reqData.params ={};
            reqData.req = obj.req;
            reqData.url = "/api/noti/call/deleteCallAll";
            reqData.method = "post";
            //프로그레스바 시작 
            this.loader = this.$loading.show();
            obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(res => {
                    //프로그레스바 종료
                    this.loader.hide();
                    if(res.errorCode != null){
                        console.log(res.errorMessage)
                    }else{
                        this.getCallList();
                        obj.toastInfo.message = obj.$i18nUtil.trans("message.TargetCall.003","전체 호출이 삭제되었습니다.");
                        obj.showToast(obj.toastInfo);
                        obj.setNoneCallReadYn(); // 읽지 않은 호출 조회/저장
                    }
                })
                .catch(function(err) {
                    console.log(err);
                });
        },
        deleteCallRead(){
            if(this.dateArray.length == 0){
                return;
            }
            let obj = this;
            let reqData = {};
            reqData.params ={};
            reqData.req = obj.req;
            reqData.url = "/api/noti/call/deleteCallRead";
            reqData.method = "post";
            //프로그레스바 시작 
            this.loader = this.$loading.show();
            obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(res => {
                    //프로그레스바 종료
                    this.loader.hide();
                    if(res.errorCode != null){
                        console.log(res.errorMessage)
                    }else{
                        if(res.result != null){
                            this.getCallList(); 
                            obj.toastInfo.message = obj.$i18nUtil.trans("message.TargetCall.004","읽은 호출이 삭제되었습니다.");
                            obj.showToast(obj.toastInfo); 
                        }
                    }
                })
                .catch(function(err) {
                    console.log(err);
                });
        },
        readCall(item){ 
            if(item.readYn == 0){ 
                let obj = this;
                let reqData = {};
                reqData.params ={
                    calltargetId : item.callTargetId
                }; 
                reqData.req = obj.req;
                reqData.url = "/api/noti/call/readCall";
                reqData.method = "post";
                obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(res => {
                    if(res.errorCode != null){
                        console.log(res.errorMessage)
                    }else{ 
                        for(let k in this.callList){ 
                            if(this.callList[k].callTargetId == item.callTargetId){
                                this.callList[k].readYn = 1;
                            }
                        } 
                        //router  
                        this.moveMessage(item);
                        //this.$router.push(item.notiLink);
                    }
                })
                .catch(function(err) {
                    console.log(err);
                }); 
            }else{
                //router  
                this.moveMessage(item); 
            }
        }, 
        moveMessage(call) {
            if(call.callLink == null || call.callLink == "" || call.callLink == undefined){
                alert(this.$i18nUtil.trans("message.TargetCall.005","잘못된 링크 입니다."));
            }else{
                //증권 호출 팝업통해 이동후 뒤로가기했을시 호출팝업 다시 노출을 위함.
                let obj = this;
         
                let reqData = {
                    url : "/api/org/getCodeValueList",
                    method : "post",
                    params : {
                    tenantId : "DEFAULT",
                    cdCategory: 'tenant.env',
                    cdKey: 'back.alarm.popup.yn'
                    }
                };
                obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(res => {
                    let codeList = res.result;
                    let mobileLoginUseTenantIds = codeList[0].cdValue;
                    let checkTenantIdArr = mobileLoginUseTenantIds.split(',');
              
                    if(call.callLink.indexOf("/board") != -1){
                        //보드 링크 
                        let obj = this;
                        let reqData = {};
                        reqData.params = {
                            paperId: call.attr2
                        };
                        reqData.req = obj.req;
                        reqData.url = "/api/copaper/paper/getPaperInfo";
                        reqData.method = "post";
                    
                        obj
                            .COWORK_REST_SIMPLE_ACTION(reqData)
                            .then(res => { 
                            if (res.errorCode != null) { 
                            } else {    
                                if(res.result.deleteYn == 0){
                                    this.setNotiBoardCommentId(null);
                                    this.setNotiBoardBlockId(null); 
                                    
                                    if(call.attr5 != null){ 
                                        this.setNotiBoardBlockId(call.attr5); 
                                    }    
                                
                                    if(call.attr6 != null){
                                        this.setNotiBoardCommentId(call.attr6);
                                    }    

                                    if(checkTenantIdArr.indexOf(this.tenantId) > -1 ){
                                        this.setShowCallListPopup(true);
                                    }
                                    this.$router.push(call.callLink);
                                }else{
                                    obj.toastInfo.message = obj.$i18nUtil.trans('TB045');
                                    obj.showToast(obj.toastInfo);
                                }
                            }
                            }).catch(function(err) { console.log(err); });
                    }else if(call.callLink.indexOf("/dashboard") != -1){
                    // 링크  getProjectInfo 
                        let obj = this;
                        let reqData = {};
                        reqData.params = {
                            projectId : call.attr1
                        };
                        reqData.req = obj.req;
                        reqData.url = "/api/cogroup/project/getProjectInfo";
                        reqData.method = "post";
                    
                        obj
                            .COWORK_REST_SIMPLE_ACTION(reqData)
                            .then(res => { 
                            if (res.errorCode != null) { 
                            } else {  
                                if(res.result.project.delDate == null){
                                    if(checkTenantIdArr.indexOf(this.tenantId) > -1 ){
                                        this.setShowCallListPopup(true);
                                    }
                                    // MESSAGE_PROJECT_OPINION_REGIST  MESSAGE_PROJECT_OPINION_REPLY
                                    if(call.callMessage == "MESSAGE_PROJECT_OPINION_REGIST" || call.callMessage == "MESSAGE_PROJECT_OPINION_REPLY"){
                                        this.$router.push(call.callLink+"?commentYn=1");
                                    }else{
                                        this.$router.push(call.callLink);
                                    }

                                    // if(call.callMessage.indexOf("의견") != -1 || call.callMessage.indexOf("답변") != -1){
                                    //     this.$router.push(call.callLink+"?commentYn=1");
                                    // }else{
                                    //     this.$router.push(call.callLink);
                                    // }
                                }else{
                                    obj.toastInfo.message = obj.$i18nUtil.trans("TB045.002");
                                    obj.showToast(obj.toastInfo);
                                }
                            }
                            }).catch(function(err) { console.log(err); });
                    }else{
                        //카테고리 링크 (회의협의, 정보공유, 프라이빗.);
                        let obj = this;
                        let reqData = {};
                        reqData.params = {
                            categoryMid : call.attr1
                        };
                        reqData.req = obj.req;
                        reqData.url = "/api/copaper/category/getCategoryInfo";
                        reqData.method = "post";
                    
                        obj
                            .COWORK_REST_SIMPLE_ACTION(reqData)
                            .then(res => { 
                            if (res.errorCode != null) { 
                            } else {   
                                if(res.result.delKbn == 0){
                                    if(checkTenantIdArr.indexOf(this.tenantId) > -1 ){
                                        this.setShowCallListPopup(true);
                                    }
                                    this.$router.push(call.callLink);
                                }else{
                                    obj.toastInfo.message = obj.$i18nUtil.trans("TB045.001");
                                    obj.showToast(obj.toastInfo);
                                }
                            }
                            }).catch(function(err) { console.log(err); });
                    }
                })
                .catch(function(err) {
                    console.log(err);
                });  
            }
        },
        selectedStartDate(date){ 
            document.body.focus();
            //console.log(this.$moment(date).format("YYYY-MM-DD"))
            this.endDisabledDate.to=new Date(this.$moment(date)); 
            this.startDate = new Date(this.$moment(date));  
            if(this.$moment(date).format("YYYY-MM-DD") > this.$moment(this.endDate).format("YYYY-MM-DD")){
            this.endDate = new Date(this.$moment(date));  
            } 
            this.getCallList();
        },
        selectedEndDate(date){
            document.body.focus();
            //console.log(this.$moment(date).format("YYYY-MM-DD")) 
            this.endDate = new Date(this.$moment(date)); 
            this.getCallList();
        },
        setTitleMessage(item){ 

            let sendUserName = this.defaultLanguage.indexOf("ko") != -1 ? item.sendUserName : item.sendUserNameEn != null ? item.sendUserNameEn : item.sendUserName;

            //21.06.28 코드값으로 변경
             if(item.callLink.indexOf("/board") == -1 ){
                let sharCheck = item.callKbn === "정보공유" ? this.$i18nUtil.trans("entity.cogroup.groupKbn.shar","정보공유")
                                                            : this.$i18nUtil.trans("entity.project","과제");
                return this.$i18nUtil.trans(item.callMessage,{sendUser:sendUserName,location:sharCheck}) 
            }else{
                let sharCheck = item.callKbn === "정보공유" ? this.$i18nUtil.trans("entity.cogroup.groupKbn.shar","정보공유")
                                                            : this.$i18nUtil.trans("entity.paper","할 일");
                return this.$i18nUtil.trans(item.callMessage,{sendUser:sendUserName,location:sharCheck}) 
            }

            // let message = item.callMessage;
            // // let message = "본문에서 님이 호출하였습니다."
            // let preMessage = message.substring(0, message.indexOf("님이"));  
            // let postMessage = message.substring(message.indexOf("님이"));
            // if(item.callLink != null && item.callLink != ""){
            //     if(item.callLink.indexOf("/board") == -1 ){
            //         return this.$i18nUtil.trans("entity.project","과제")+" "+ preMessage+'"'+item.sendUserName+'" ' + postMessage;
            //     }else{
            //         return "보드 "+ preMessage+'"'+item.sendUserName+'" ' + postMessage;
            //     }
            // }else{
            //     return preMessage+'"'+item.sendUserName+'" ' + postMessage;
            // }
        }
    },
}
</script>

<style scoped>
.history .nodata{
  width: 96%; 
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/main/modal/TargetCall.vue